import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="w-full py-12 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-139">
      <motion.div className="bg-white rounded-2xl p-6 md:p-10 shadow-diary border border-warm-brown/10 flex flex-col md:flex-row gap-8 items-center" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-140">
        <div className="flex-1 w-full relative" data-id="element-141">
          <div className="rounded-xl overflow-hidden" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/1ek9Fo1pb28y6vZMsGxrzN/Magen_Darm_4f46689c-206a-426f-9344-0505df3c965a.webp" alt="Hunderunde Futtertopping Magen & Darm Verpackung" className="w-full h-auto object-contain rounded-xl" data-id="element-143" />
          </div>
        </div>

        <div className="flex-1 space-y-4" data-id="element-144">
          <h3 className="font-handwritten text-3xl md:text-4xl text-forest-green font-bold" data-id="element-145">
            Was ich bestellt habe
          </h3>
          <p className="text-gray-700 leading-relaxed font-serif text-lg" data-id="element-146">
            Nach langer Recherche habe ich mich für das Magen-Darm-Topping von
            Hunderunde entschieden, weil es komplett natürlich ist und genau die
            schützenden Ballaststoffe enthält, die Rex jetzt brauchte. Es war
            das einzige Produkt, das auf unnötige Füllstoffe verzichtet und sich
            so einfach über das tägliche Futter streuen lässt.
          </p>
        </div>
      </motion.div>
    </section>;
}